import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import Grid from '@mui/material/Grid';
import Collapse from '@mui/material/Collapse';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ClearSharp from '@mui/icons-material/ClearSharp';
import OpenInNewSharpIcon from '@mui/icons-material/OpenInNewSharp';
import DoneSharp from '@mui/icons-material/DoneSharp';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import { CardHeader } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  root: {

  },
  card: {
    maxWidth: 345,
    position: 'sticky',
    left: '0',
    margin: '3px 0',
  },
  cardContent: {
    [theme.breakpoints.down('sm')]: {
      display: "flex",
    },
  },
  text: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem',
    },
  },
  media: {
    // height: 140, // 

    [theme.breakpoints.down('sm')]: {
      width: '33%',
    },
  },
  grid: {
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(1),
    },
  },
  tableCell: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0,
      fontSize: '0.6rem',
    },
  },
  detailTableCell: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem',
    },
  },
}));


const CheckMarkIcon = (props) => {

  if (props.value === true) {
    return (<DoneSharp color="action" />);
  } else {
    return (<ClearSharp color="error" />);
  }
}

const MowerTableRow = ({ row, index, installationPrice, gardenSizeInput }) => {


  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const labelId = `enhanced-table-checkbox-${index}`;
  const installationLinkUrl = 'https://mähroboter-installation.de?installationType=undergroundInstallation&area=' + gardenSizeInput;


  return (
    <React.Fragment>
      <TableRow
        className={classes.root}
        hover
        // onClick={(event) => handleClick(event, row.name)}
        role="checkbox"
        tabIndex={-1}
        key={row.acf.name ? row.acf.name : 'Missing'}
        onClick={() => setOpen(!open)}
      >

        <TableCell className={classes.tableCell} component="th">
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell className={classes.tableCell} id={labelId} padding='none'>
          {row.acf.name ? row.acf.name : 'Missing'}
        </TableCell>

        <TableCell className={classes.tableCell} align="center" >{row.acf.rand_in_cm} cm</TableCell>
        <TableCell className={classes.tableCell} align="center" >{row.acf.lautstarke} db</TableCell>
        <TableCell className={classes.tableCell} align="center" >{row.acf.flachenleistung_pro_akkulaufzeit} m²</TableCell>
        <TableCell className={classes.tableCell} align="center" padding='none'><CheckMarkIcon value={row.acf.regensensor} /></TableCell>
        <TableCell className={classes.tableCell} align="center" padding='none'><CheckMarkIcon value={row.acf.display_menu} /></TableCell>
        <TableCell className={classes.tableCell} align="center" padding='none'>{row.acf.passagesize} cm</TableCell>
        <TableCell className={classes.tableCell} align="center" padding='none'>
          <span style={{ verticalAlign: "super" }}><b>ab {row.acf.preis_value} €</b></span>&nbsp;&nbsp;
          <Link href={row.acf.preisvergleich_url} target="_blank">
            <OpenInNewSharpIcon />
          </Link>
        </TableCell>
        <TableCell className={classes.tableCell} align="center" padding='none'>
          <span style={{ verticalAlign: "super" }}><b>{installationPrice}</b></span>
          <Link href={installationLinkUrl} target="_blank">
            <OpenInNewSharpIcon />
          </Link>
        </TableCell>

      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Grid
              container
              direction="row"
              justify="space-evenly"
              alignItems="center"
              className={classes.grid}
            >
              <Grid item xs={12} sm={5}>
                <Card className={classes.card} elevation={2} >
                  <CardHeader title={row.acf.name ? row.acf.name : 'Missing'} titleTypographyProps={{ variant: "body2" }} />
                  <CardActionArea className={classes.cardContent}>
                    <CardMedia
                      component="img"
                      className={classes.media}
                      image={row.acf.image.sizes.medium}
                      title={row.acf.name ? row.acf.name : 'Missing'}
                    />
                    <CardContent className={classes.cardContent}>
                      <Typography variant="body2" color="textSecondary" component="p" className={classes.text}>
                        {row.acf.besonderheit}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button size="small" color="primary" href={row.acf.produkt_webseite_url} target="_blank">
                      Produktseite
                    </Button>
                    <Button size="small" color="primary" href={row.acf.preisvergleich_url} target="_blank">
                      Preisvergleich
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={5}>
                <Card className={classes.card} elevation={0}>
                  <CardActionArea>
                    <CardHeader title='Details' titleTypographyProps={{ variant: "body2" }} />
                    <CardContent>
                      <Table size="small" aria-label="purchases" >
                        <TableBody>
                          <TableRow>
                            <TableCell className={classes.detailTableCell} align="right">Max. Flächen kapazität</TableCell>
                            <TableCell className={classes.detailTableCell} align="left">{row.acf.gardensize} m²</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.detailTableCell} align="right">Max. Steigung</TableCell>
                            <TableCell className={classes.detailTableCell} align="left">{row.acf.inclination} %</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.detailTableCell} align="right">Kabellos</TableCell>
                            <TableCell className={classes.detailTableCell} align="left"><CheckMarkIcon value={row.acf.cabelless} /></TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.detailTableCell} align="right">Schnittbreite</TableCell>
                            <TableCell className={classes.detailTableCell} align="left">{row.acf.schnittbreite} cm</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.detailTableCell} align="right">Schnitthöhe</TableCell>
                            <TableCell className={classes.detailTableCell} align="left">{row.acf.schnitthohe_min} cm bis {row.acf.schnitthohe_max} cm</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.detailTableCell} align="right">Akkulaufzeit</TableCell>
                            <TableCell className={classes.detailTableCell} align="left">{row.acf.akkulaufzeit} min</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.detailTableCell} align="right">Akkuladezeit</TableCell>
                            <TableCell className={classes.detailTableCell} align="left">{row.acf.akkuladezeit} min</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.detailTableCell} align="right">Gewicht</TableCell>
                            <TableCell className={classes.detailTableCell} align="left">{row.acf.gewicht_in_kg} Kg</TableCell>
                          </TableRow>
                          <TableRow>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </CardContent>
                  </CardActionArea>

                </Card>
              </Grid>
            </Grid>


          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default MowerTableRow;
